import { afterNextRender, ChangeDetectionStrategy, Component, computed, effect, inject, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { GoogleAnalytics } from './google-analytics.js';
import { AuthService } from '@zvoove-market/shared';

@Component({
  selector: 'app-google-analytics-tracking',
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class GoogleAnalyticsTracking {
  public constructor() {
    const ga = inject(GoogleAnalytics);

    afterNextRender(() => {
      if (!ga.wasConsentConfigured()) {
        ga.openConsentDialog();
      }
    });

    // Track user
    const auth = inject(AuthService);
    const userId = computed<string | null>(() => auth.$context().userId);
    effect(() => {
      if (ga.gaLoaded()) {
        ga.addUserId(userId());
      }
    });
    effect(() => {
      if (ga.gaLoaded()) {
        ga.addUserProperties(auth.$context());
      }
    });

    // Track page views
    const router = inject(Router);
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        ga.trackPageView(document.title, document.location.origin + event.urlAfterRedirects);
      }
    });
  }
}
